import { useScreenSize } from '@ltvco/refresh-lib/utils';
import {
  Control,
  FieldErrors,
  UseFormRegister,
} from '@ltvco/refresh-lib/vendors';
import { memo } from 'react';

import { SearchInput } from '../SearchInput';

import { PersonFormData } from './PersonSearch';

interface PersonSmartSearchInputProps {
  register: UseFormRegister<PersonFormData>;
  placeholder: string;
  errors: FieldErrors<PersonFormData>;
  // eslint-disable-next-line no-unused-vars
  clearErrors: (field?: string) => void;
  onClear: () => void;
  value: string;
  control: Control<PersonFormData>;
  // eslint-disable-next-line no-unused-vars
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line no-unused-vars
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const PersonSmartSearchInput = memo(
  ({
    register,
    placeholder,
    errors,
    clearErrors,
    onClear,
    value,
    control,
    onFocus,
    onBlur,
  }: PersonSmartSearchInputProps) => {
    const { isMobile } = useScreenSize();
    const registerReturn = register('name');

    return (
      <SearchInput
        registerReturn={registerReturn}
        label={isMobile ? 'Person' : 'People'}
        placeholder={placeholder}
        error={errors.name}
        clearErrors={clearErrors}
        onClear={onClear}
        value={value}
        control={control as unknown as Control}
        fieldName="name"
        autoFocus
        onFocus={onFocus}
        onBlur={onBlur}
      />
    );
  }
);
